import { createApp } from 'vue';

import StatCardsContainerBlock from './StatCardsContainerBlock.vue';

function mountStatCardsContainerBlocks() {
	const blocks = document.querySelectorAll('[data-feature="stat-cards-container-block"]');

	blocks.forEach((block) => {
		const app = createApp({
			name: 'StatCardsContainerBlockApp',
		});

		app.component('stat-cards-container-block', StatCardsContainerBlock);
		app.mount(block);
	})
}

mountStatCardsContainerBlocks();